module.exports = __webpack_public_path__ + "img/qiye.38d8a643.png";